import { logGroup } from 'log';
import { loggerService } from 'js/services/logger.service';
import { type AnyAction, type MiddlewareAPI, type Dispatch } from 'redux';

import * as Types from './types';

export const logger = (api: MiddlewareAPI) => (next: Dispatch<AnyAction>) => (action: Types.ILoggerAction) => {
    if (action.type && !action.isSilent && loggerService.isReduxEnabled()) {
        const logMessages = [];

        logMessages.push(['redux', { description: 'action', ...action }]);
        logMessages.push(['redux', { description: 'prev state', ...api.getState() }]);

        const result = next(action);

        logMessages.push(['redux', { description: 'next state', ...api.getState() }]);
        logGroup('redux', { description: `dispatching ${action.type}` }, logMessages);

        return result;
    }

    return next(action);
};
